import { render, staticRenderFns } from "./BoxSearchCommon.vue?vue&type=template&id=70f69a5e&"
import script from "./BoxSearchCommon.vue?vue&type=script&lang=js&"
export * from "./BoxSearchCommon.vue?vue&type=script&lang=js&"
import style0 from "./BoxSearchCommon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports